import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/Vintage-Poshmark';

export default function Example() {
  return (
    <>
      <Head>
        <title>A Poshmark Reseller Guide: Where To Get Real Vintage Pieces</title>
        <meta
          name='description'
          content='Poshmark is not a vintage platform. As such, it is not easy to sell vintage. So, sellers must be very strategic about price, inventory, and sourcing items that you can resell on this online store.'
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/Vintage-Poshmark' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/Vintage-Poshmark' />
        <meta property='og:title' content='A Poshmark Reseller Guide: Where To Get Real Vintage Pieces' />
        <meta
          property='og:description'
          content='Poshmark is not a vintage platform. As such, it is not easy to sell vintage. So, sellers must be very strategic about price, inventory, and sourcing items that you can resell on this online store.'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=4' />
        <meta property='article:published_time' content='2022-01-22T00:00:00.000Z' />
        <meta property='article:modified_time' content='2022-01-22T00:00:00.000Z' />
        <meta property='article:tag' content='Vinted' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
